import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import { SocialIcon } from 'react-social-icons';
import Select, { components } from "react-select";
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import Popup from 'reactjs-popup';
import PhoneInput from 'react-phone-number-input/input';
import CheckBox from '../../components/checkbox/checkbox.component';
import Button from '../../components/button/button.component';
import { showWarningLayer } from '../../utils/utils';
import 'reactjs-popup/dist/index.css';
import './step5.styles.scss';

class Step5 extends React.Component{
  constructor(props){
    super(props);
    this.scrollRef = React.createRef()  
    this.state = {
      showInfo:(this.props.step5.showInfo !== undefined && this.props.step5.showInfo === true) ? true : false,
      disablePhone:(this.props.step5.phone !== undefined && this.props.step5.phone.length > 0) ? false : true,
      disableEmail:(this.props.step5.email !== undefined && this.props.step5.email.length > 0) ? false : true,
      socialLink:'',
      iletisimTercihleri: (this.props.step5.iletisimTercihleri === null || this.props.step5.iletisimTercihleri === undefined || !Array.isArray(this.props.step5.iletisimTercihleri)) ? [] : this.props.step5.iletisimTercihleri, 
      gizliTercihler: (this.props.step5.gizliTercihler === null || this.props.step5.gizliTercihler === undefined || !Array.isArray(this.props.step5.gizliTercihler)) ? [] : this.props.step5.gizliTercihler, 
      socials: (this.props.step5.socials === null || this.props.step5.socials === undefined || !Array.isArray(this.props.step5.socials)) ? [] : this.props.step5.socials,
      socialPrefix:'https://www.facebook.com/',
      formOpen: false
    };

    if (this.props.step5.gizliTercihler === null || this.props.step5.gizliTercihler === undefined){
      this.props.setStep5({
        ...this.props.step5,
        gizliTercihler: []
      });    
    }

    if (this.props.step5.iletisimTercihleri === null || this.props.step5.iletisimTercihleri === undefined){
      this.props.setStep5({
        ...this.props.step5,
        iletisimTercihleri: []
      });    
    }

    this.handleSocialLinkChange = this.handleSocialLinkChange.bind(this);
    this.addToSocials = this.addToSocials.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleIletisimTercihleri = this.handleIletisimTercihleri.bind(this);
    this.handleGizliTercihler = this.handleGizliTercihler.bind(this);
    this.handleTableTicks = this.handleTableTicks.bind(this);
    this.handleGizliPhoneChange = this.handleGizliPhoneChange.bind(this);
    this.handleGizliEmailChange = this.handleGizliEmailChange.bind(this);
    this.handleScrollToElement = this.handleScrollToElement.bind(this);

    this.options = [
      { custom: true, typex:"facebook", link:"https://www.facebook.com/", label:"Facebook", value:"facebook" },
      { custom: true, typex:"twitter", link:"https://twitter.com/",label:"Twitter", value:"twitter"  },
      { custom: true, typex:"instagram", link:"https://www.instagram.com/", label:"Instagram", value:"instagram"  },
      { custom: true, typex:"linkedin", link:"https://www.linkedin.com/in/", label:"LinkedIn", value:"linkedin"  },
      { custom: true, typex:"youtube", link:"https://www.youtube.com/channel/", label:"YouTube", value:"youtube"  }
    ];      

  }

  UNSAFE_componentWillMount(){
    this.props.setStep5({
      ...this.props.step5,
      rizaMetni: false
    }); 

  }

  handleScrollToElement(event) {
    this.scrollRef.current.scrollTo(0,0);
  }

  handlePhoneChange(value){
    this.props.setStep5({
      ...this.props.step5,
      phone:value
    })    
  }  

  handleEmailChange(event){
    this.props.setStep5({
      ...this.props.step5,
      email:event.target.value
    })    
  }

  handleGizliPhoneChange(value){
    this.props.setStep5({
      ...this.props.step5,
      gizliphone:value
    })    
  }

  handleGizliEmailChange(event){
    this.props.setStep5({
      ...this.props.step5,
      gizliemail:event.target.value
    })    
  }    

  handleIsContactShow = (val) => {
    let tmpCheck = false;
    if (val === "1"){
      tmpCheck = true;
    }
    this.setState(()=>({
      ...this.state,
      showInfo: tmpCheck
    }));

    this.props.setStep5({
      ...this.props.step5,
      showInfo: tmpCheck
    });         

  }  

  handleCheck = (target) => {
    let tmpCheck = true;
    if (target.checked === true){
      tmpCheck = false;
    }
    
    if (target.name === "contactPhone"){
      this.setState(()=>({
        ...this.state,
        disablePhone: tmpCheck
      }));

      this.props.setStep5({
        ...this.props.step5,
        disablePhone: tmpCheck
      });      

      if (tmpCheck === false){
        setTimeout(()=> {
          this.phoneInput.focus();
        },50);
        
      }
  
    }else if (target.name === "contactEmail"){
      this.setState(()=>({
        ...this.state,
        disableEmail: tmpCheck
      }));

      this.props.setStep5({
        ...this.props.step5,
        disableEmail: tmpCheck
      });          

      if (tmpCheck === false){
        setTimeout(()=> {
          this.emailInput.focus();
        },50);        
      }
    }
  }  

  handleIletisimTercihleri = changeEvent => {
    const { name } = changeEvent.target;
    const newArray = this.state.iletisimTercihleri.slice();    
    
    if (changeEvent.target.checked === true){
      if (newArray.indexOf(name) === -1) {
        newArray.push(name);
      }    
      this.setState({
        ...this.state,
        iletisimTercihleri: newArray,
      });
  
      this.props.setStep5({
        ...this.props.step5,
        iletisimTercihleri:newArray
      })    

    }else{
      const newList = [...this.state.iletisimTercihleri];
      var tmpIndex = newList.indexOf(name);
      if (tmpIndex !== -1){
        newList.splice(tmpIndex,1);
        this.setState({
          ...this.state,
          iletisimTercihleri: newList
        })
        this.props.setStep5({
          ...this.props.step5,
          iletisimTercihleri:newList,
        })      
      }
    }
    
  };

  handleTableTicks = changeEvent => {
    const { name } = changeEvent.target;
    
    if (changeEvent.target.checked === true){
      this.setState({
        ...this.state,
        [name]:true
      });
  
      this.props.setStep5({
        ...this.props.step5,
        [name]:true
      })    

    }else{
      this.setState({
        ...this.state,
        [name]:false
      });
  
      this.props.setStep5({
        ...this.props.step5,
        [name]:false
      })  
    }
    
  };

  
  CustomOption = props => {
    const { data, innerRef, innerProps } = props;
    return data.custom ? (
      <div className="socialSelectWrapper" ref={innerRef} {...innerProps}>
        <SocialIcon className="socialMediaIcon" network={data.typex} style={{ height: 30, width: 30 }}  /> 
      </div>
    ) : (
      <components.Option {...props} />
    );
  };  

  formatOptionLabel = ({ typex }) => (
    <SocialIcon network={typex} className="socialMediaIcon" style={{ height: 30, width: 30 }} />
  );  
  
  handleGizliTercihler = changeEvent => {
    const { name } = changeEvent.target;
    const newArray = this.state.gizliTercihler.slice();    

    if (changeEvent.target.checked === true){
      if (newArray.indexOf(name) === -1) {
        newArray.push(name);
      }    
      this.setState({
        ...this.state,
        gizliTercihler: newArray,
        [name]: true
      });
  
      this.props.setStep5({
        ...this.props.step5,
        gizliTercihler:newArray,
        [name]: true
      })    

    }else{
      const newList = [...this.state.gizliTercihler];
      var tmpIndex = newList.indexOf(name);
      if (tmpIndex !== -1){
        newList.splice(tmpIndex,1);
        this.setState({
          ...this.state,
          gizliTercihler: newList,
          [name]: false
        })
        this.props.setStep5({
          ...this.props.step5,
          gizliTercihler:newList,
          [name]: false
        })      
  
      }
    }
  };   

  handleGizliEmailCheck = changeEvent => {
    if (changeEvent.target.checked === true){
      this.props.setStep5({
        ...this.props.step5,
        gizliemailcheck:true
      })    
    }else{
        this.props.setStep5({
          ...this.props.step5,
          gizliemailcheck:false
        })      
    }
  };   

  handleSocialLinkChange(event){
    this.setState({
      ...this.state,
      socialLink: event.target.value
    })
  }

  addToSocials(){
    let newLink = this.state.socialLink;
    if (newLink.length < 2){
      const warnmessage = this.props.language.keywords.lutfenGecerliBirBaglantiGirin;
      this.props.onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
      showWarningLayer();
      return;
    }

    newLink = this.state.socialPrefix + newLink;

    const newArray = this.state.socials.slice();  
    if (newArray.indexOf(newLink) === -1) {
      newArray.push(newLink);
    }

    this.setState({
      ...this.state,
      socials: newArray,
      socialLink:''
    });

    this.props.setStep5({
      ...this.props.step5,
      socials:newArray
    });      
  }

  removeItem(item,index){
    const newList = [...this.state.socials];
    var tmpIndex = newList.indexOf(item);
    if (tmpIndex !== -1){
      newList.splice(index,1);
      this.setState({
        ...this.state,
        socials: newList
      })
      this.props.setStep5({
        ...this.props.step5,
        socials:newList,
      })      

    }
  }

  handleRizaMetni = (event) => {
    let tmpCheck = false;
    if (event.target.checked === true){
      tmpCheck = true;
    }
    this.props.setStep5({
      ...this.props.step5,
      rizaMetni: tmpCheck
    }); 
  }    

  handleSocialChange = (event) => {
    this.setState({
      ...this.state,
      socialPrefix: event.link
    });    
  }


  setOpen = (val) =>{
    this.setState({
      ...this.state,
      formOpen: val
    })
  }


  closeModal = () => {
    this.setOpen(false)
  }


  componentDidMount(){
    this.props.setCurrent('step-5');
    window.scrollTo(0,0);
  } 
  render(){
    return(
      <React.Fragment>
        <section className="sectionStepNew">
          <Header currentPage="step-5" />
          <div className="sectionWrapperNew">
            <div className="gridWrapper gridWrapperStep5">
              <div className="firstColumn">
                <h4 className="sectionTitle">{this.props.language.keywords.sosyalMedyaHesaplariniz}</h4>
                <div className="baglantiWrapper">
                  <Select 
                    className="socialSelect"
                    placeholder=""
                    defaultValue={{custom: true, typex:"facebook", link:"https://www.facebook.com/", label:"Facebook", value:"facebook"}}
                    formatOptionLabel={this.formatOptionLabel}
                    components={{ Option: this.CustomOption }}
                    options={this.options} 
                    isSearchable={false}
                    color="#506c53"
                    onChange={this.handleSocialChange}


                  />              
                  <input type="text" placeholder={this.props.language.keywords.hesapAdi} className="edits-login edit-account-name" value={this.state.socialLink} onChange={this.handleSocialLinkChange} />
                  <Button className="btn-add-to-socials" onClick={this.addToSocials}><svg className="nextButton" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><polygon points="0,0 32,16 0,32"/></g></svg></Button>                  
                  
                </div>
                <div className="componentWrapper step5-layer1">
                  <div className=" step5SosyalMedya ">
                    <ul className="ulSosyalHesaplar">
                    {
                      this.state.socials.map((item,index)=>(
                        <li key={index} title={item}><button className="btn-remove-list" onClick={() => this.removeItem(item,index)} ></button><div className="socialLine"><SocialIcon className="socialMediaIcon" style={{ height: 30, width: 30 }} url={item} /> <span className="socialMedyaInfo">{item}</span></div> </li>
                      ))
                    }
                    </ul>
                  </div>
                </div>
              </div>
              <div className="secondColumn">
                <div className="medyaDeneyimiRadioGroupWrapper">
                  <div name="medyaDeneyimi" className="medyaDeneyimiRadioGroup">
                    <div value="0" name="iletisimBilgileri" className="iletisimBilgileriCheckGroupPres">
                      <div className="formBox0">
                        <h4 className="sectionTitle">{this.props.language.keywords.iletisimBilgileriniz}</h4>                  
                      </div>
                      <div className="formBox1">
                        <h4 className="sectionTitle subtitle">{this.props.language.keywords.profilimdeGorunsun}</h4>
                      </div>

                      <div className="formBox4">
                      <PhoneInput
                        placeholder={this.props.language.keywords.telefonNumaraniziGiriniz}
                        value={this.props.step5.phone}
                        onChange={this.handlePhoneChange}
                        className="edits-login"
                        defaultCountry="TR"
                      />                    
                      </div>                  
                      <div className="formBox5">
                        <CheckBox value="" className="contactCheck" name="tercihphoneshow" checked={ (this.props.step5.tercihphoneshow === undefined || this.props.step5.tercihphoneshow === null) ? false : this.props.step5.tercihphoneshow} defaultCheck={false}  onChange={this.handleTableTicks}></CheckBox> 
                      </div>                  
               
                      <div className="formBox8">
                        <input type="text" ref={(input) => { this.emailInput = input; }} placeholder={this.props.language.keywords.epostaAdresiniziGiriniz} className="edits-login" value={this.props.step5.email} onChange={this.handleEmailChange} />
                      </div>                  
                      <div className="formBox9">
                        <CheckBox value="" className="contactCheck" name="tercihemailshow" checked={ (this.props.step5.tercihemailshow === undefined || this.props.step5.tercihemailshow === null) ? false : this.props.step5.tercihemailshow } defaultCheck={false} onChange={this.handleTableTicks}></CheckBox> 
                      </div>                  
                     
                      <div className="formBox11">
                        <CheckBox value="rizametni" className="onayTick" defaultCheck={false} onChange={this.handleRizaMetni}><span className="on-bilgilendirme-formu-text" onClick={() => this.setOpen(true)}><u>{this.props.language.keywords.aydinlantmaMetniOnBilgilendirmeFormu}</u></span></CheckBox>
                      </div>
                    </div>     
                  </div>  
                </div>
              </div>
            </div>
          </div>          
          <Footer currentPage="step-5" parentPage="step-4" />
        </section>
        <Popup open={this.state.formOpen} closeOnDocumentClick onClose={this.closeModal} onOpen={this.handleScrollToElement} position="top center">
          <button className="fixclose" onClick={this.closeModal}><img src="/assets/images/close-button.png" alt="" className="closeButton" /></button>
          <div ref={this.scrollRef} className="modal modalForm">
            <div className="modalWrapper">
              {
                this.props.language.short === "TR" ?
                  <React.Fragment>
                    <p className="textCenter"><strong>SENSİZ OLMAZ, SESSİZ OLMAZ PROJESİ KAPSAMINDA</strong></p>
                    <p className="textCenter"><strong>KİŞİSEL VERİLERİN İŞLENMESİ VE GÜVENLİĞİNE İLİŞKİN</strong></p>
                    <p className="textCenter"><strong>AÇIK RIZA ONAY FORMU</strong></p>
                    <p><strong>&nbsp;</strong></p>
                    <p><i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen "Sensiz olmaz, Sessiz olmaz" Projesi </i> ve Portal'ı kapsamında veri sahibince düzenlenen Kişisel verilen işlenmesine ilişkin aydınlatma metnini (<a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf</a>) okuduğumu, anladığımı bu metinde yer alan kişisel verilerimin (özel nitelikli kişisel verilerim dahil)  işlenme amaçları, yurt içinde ve yurt dışında aktarıldığı kurum, kuruluş, 3. Kişiler ile  toplanma yöntemleri ve hukuki sebepleri, kişisel verilerimin korunmasına yönelik haklarım, veri güvenliği ve başvuru hakkıma dair bilgilendirildiğimi, Kişisel verilerimin ve Özel Nitelikli Kişisel Verilerimin veri sorumlusu sıfatıyla Par Araştırma ve Danışmanlık Anonim Şirketi veya gerekli güvenlik tedbirlerini aldırmak suretiyle yetkilendirdiği veri işleyenler tarafından; faaliyeti kapsamında tabii olduğu tüm mevzuatlar gereği yükümlülüklerini yerine getirmek, faaliyeti kapsamındaki hizmetlerinin verilebilmesi için akdedilen hizmetlere konu sözleşmelerin koşullarının ifası ve üstlenilen yükümlülükleri yerine getirebilmek, veri sahibi hakkında değerlendirmelerin  yapılması, istihbarat, bilgi araştırmaları, planlama, istatistiki çalışmaların yapılabilmesi, veri sahibinin geçmişi, istatistiki verileri, vb. ile ilgili verilerini analiz etmesi sırasında  hizmetlerin en iyi şekilde sunulabilmesi için kullanmak sureti ile geliştirilmesi; veri sahibine  sunulan  hizmetlerinin güncel durumu ve güncellemeler ile ilgili veri sahibi ile iletişime geçilebilmesi, bu hususta gerekli bilgilendirmelerin yapılabilmesi, anlaşmalı kurumları ve çözüm ortakları tarafından veri sahibine öneri sunabilmek, hizmetlerimizle ilgili bilgilendirebilmek, hizmetlerimiz ile ilgili şikayet ve önerilerini değerlendirebilmek, yasal yükümlülüklerimizi yerine getirebilmek ve yürürlükteki mevzuattan doğan haklarımızı kullanabilmek, <strong>Portal</strong> tarafından sunulan hizmetlerin üyelerin araştırmalarına ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması ve icrası, <strong>Portal</strong> tarafından sunulan hizmetlerin üyelerin araştırmalarına ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması, <strong>Portal</strong> tarafından sunulan hizmetlerden üyeleri faydalandırmak için gerekli çalışmaların proje birimleri tarafından yapılması ve ilgili süreçlerinin yürütülmesi, <strong>Portal</strong> tarafından yürütülen faaliyetlerin gerçekleştirilmesi için ilgili proje birimleri tarafından gerekli çalışmaların yapılması ve buna bağlı süreçlerinin yürütülmesi, <strong>Portal</strong>‘ın  bağlı olduğu Sensiz Olmaz Sessiz Olmaz projesi kapsamında stratejilerinin planlanması, geliştirilmesi ve icrası, <strong>Portal</strong>‘ın ve <strong>Portal</strong>‘la ilişki içerisinde olan kişilerin, hukuki ve teknik güvenliğinin temini, toplu iletişimi hızlandıran firmalar ve bağımsız denetim firmalarına aktarılabilmek amaçlarıyla toplanmasına; başta mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme ilkesi olmak üzere 6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun (“KVK Kanunu”) 4. maddesinde ifade edilen genel ilkelere uygun şekilde işlenebileceğini; elde edilebileceğini, kaydedilebileceğini, işlenme amacıyla uygun süre zarfında fiziksel veya elektronik ortamda güvenli bir şekilde depolanabileceğini, muhafaza edilebileceğini, değiştirilebileceğini, yeniden düzenlenebileceğini, mevzuata uygun biçimde açıklanabileceğini ve aktarılabileceğini, devralınabileceğini, sınıflandırılabileceğini, işlenebileceğini ya da verilerin kullanılmasının engellenebileceğini; rıza ve onay verdiğim ölçüde kişisel bilgilerimin site ziyaretçileri tarafından erişilebilir olacağını, yukarıda belirtilen hususlarla ilgili olarak bilgilendirildiğimi, KVK Kanunu çerçevesinde <strong>AÇIK RIZAM VE ONAYIMIN bulunduğunu kabul ve beyan ederim.</strong></p>
                    <p>İlaveten, KVK Kanunu’nun 11.maddesi ve ilgili mevzuat uyarınca; <i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen “Sensiz olmaz, Sessiz olmaz” Projesi</i> ve Portal’ına  başvurarak kendimle ilgili; kişisel veri işlenip işlenmediğini öğrenme, kişisel verilerim işlenmişse buna ilişkin bilgi talep etme, kişisel verilerimin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme, yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme, kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme, işbu verilerin işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerimin silinmesini veya yok edilmesini isteme, bu düzeltme ve silinme taleplerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme, işlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kendi aleyhime bir sonucun ortaya çıkmasına itiraz etme, kişisel verilerimin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme haklarımın olduğunu ve bu hakları kullanmak için kimliğimi tespit edici gerekli bilgiler ile kullanmayı talep ettiğim hakkıma yönelik açıklamaları da içeren talebimi (<a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/basvuruformu.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/basvuruformu.pdf</a>) Maslak Mah. Eski Büyükdere Cad. No.37 İçkapı no 8 Sarıyer/İstanbul adresinde bulunan Par Araştırma ve Danışmanlık Anonim Şirketine  kimliğimi tespit edici belgeler ile bizzat elden iletme yahut noter kanalıyla veya KVK Kanunu’nda belirtilen diğer yöntemler ile iletme hakkına sahip olduğumu kabul ediyorum.</p>
                    <p>Ayrıca, <i>Par Araştırma ve Danışmanlık Anonim Şirketi tarafından yürütülen “Sensiz olmaz, Sessiz olmaz” Projesi</i> ve Portal’ı ile paylaşmış olduğum kişisel verilerin doğru ve güncel olduğunu; işbu bilgilerde değişiklik olması halinde değişiklikleri bildireceğimi kabul ve beyan ederim.</p>
                    <p>KVK Kanunu’nda tanımlanan özel nitelikli kişisel verilerim de dahil olmak üzere ilgili kişisel verilerimin işlenmesine, ilgili süreç kapsamında işlenme amacı ile sınırlı olmak üzere kullanılmasına ve paylaşılmasına, gereken süre zarfında saklanmasına açık rızam olduğunu ve bu hususta tarafıma gerekli aydınlatmanın yapıldığını; işbu metni, Sensiz Olmaz, Sessiz Olmaz projesi kapsamında  Kişisel Verilerin İşlenmesine ilişkin Aydınlatma/Bilgilendirme Metnini okuduğumu ve anladığımı, Veri Sahibi Başvuru Formu hakkında bilgilendirildiğimi ve Kişisel Verilerin Korunması Kanunu Kapsamında <strong>Açık Rıza Onay formunu  kabul ediyorum.</strong></p>
                    <p>Kişisel verilerin işlenmesi ve korunmasına ilişkin politikamız <a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/politika.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/politika.pdf</a></p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>              
                  </React.Fragment>  :
                  <React.Fragment>
                    <p className="textCenter"><strong>WITHIN THE SCOPE OF THE WOMEN VOICES PROJECT</strong></p>
                    <p className="textCenter"><strong>REGARDING THE PROCESSING AND SECURITY OF PERSONAL DATA</strong></p>
                    <p className="textCenter"><strong>EXPLICIT CONSENT APPROVAL FORM</strong></p>
                    <p><strong>&nbsp;</strong></p>

                    <p><i>Within the scope of the "Women Voices" Project conducted by Par Araştırma ve Danışmanlık Anonim Şirketi</i> and the Portal, I have read and understood the information text regarding the processing of personal data prepared by the data subject (<a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf" target="_blank">www.sensizolmazsessizolmaz.org/soso-aydinlatma-metni.pdf</a>). I have been informed about the purposes of processing my personal data (including my special category personal data), the institutions, organizations, and third parties to whom it is transferred domestically and abroad, the methods and legal reasons for collection, my rights regarding the protection of my personal data, data security, and my right to apply. I acknowledge and declare that my personal data and special category personal data can be processed by Par Araştırma ve Danışmanlık Anonim Şirketi as the data controller or by authorized data processors who take necessary security measures; to fulfill its obligations under all applicable legislation, to perform the conditions of the contracts related to the services provided within the scope of its activities, to make evaluations about the data subject, to conduct intelligence, information research, planning, and statistical studies, to analyze the data subject's history, statistical data, etc., to develop services to be provided in the best way, to communicate with the data subject about the current status and updates of the services provided, to make necessary notifications, to offer suggestions to the data subject by contracted institutions and solution partners, to inform about our services, to evaluate complaints and suggestions about our services, to fulfill our legal obligations and to exercise our rights arising from the applicable legislation, to plan and execute the necessary activities for the customization and promotion of the services provided by the <strong>Portal</strong> according to the research and needs of the members, to carry out the necessary work by the project units for the members to benefit from the services provided by the <strong>Portal</strong> and to manage the related processes, to carry out the necessary work by the project units for the activities carried out by the <strong>Portal</strong> and to manage the related processes, to plan, develop and execute the strategies within the scope of the Women Voices project to which the <strong>Portal</strong> is affiliated, to ensure the legal and technical security of the <strong>Portal</strong> and the persons in relation with the <strong>Portal</strong>, to transfer to companies that accelerate mass communication and independent audit firms; to be processed in accordance with the general principles stated in Article 4 of the Law on the Protection of Personal Data No. 6698 ("KVK Law"), including the principle of retaining for the period stipulated in the relevant legislation or required for the purpose for which they are processed; to be obtained, recorded, securely stored in physical or electronic media for the appropriate period for the purpose of processing, retained, altered, rearranged, disclosed and transferred in accordance with the legislation, taken over, classified, processed or prevented from being used; to the extent that I have given my consent and approval, my personal information will be accessible by site visitors, I have been informed about the above-mentioned issues, and I acknowledge and declare that I have <strong>EXPLICIT CONSENT AND APPROVAL</strong> within the framework of the KVK Law.</p>
                    
                    <p>Additionally, pursuant to Article 11 of the KVK Law and relevant legislation; by applying to the <i>"Sensiz olmaz, Sessiz olmaz" Project</i> and Portal conducted by Par Araştırma ve Danışmanlık Anonim Şirketi, I have the right to learn whether my personal data is processed, to request information if my personal data has been processed, to learn the purpose of processing my personal data and whether they are used in accordance with their purpose, to know the third parties to whom personal data is transferred domestically or abroad, to request the correction of personal data if it is incomplete or incorrectly processed, to request the deletion or destruction of personal data if the reasons for processing them no longer exist, to request that these correction and deletion requests be notified to third parties to whom personal data has been transferred, to object to the emergence of a result against me by analyzing the processed data exclusively through automated systems, and to demand compensation for the damage if my personal data is processed unlawfully. I acknowledge that I have the right to submit my request, which includes explanations about the right I want to use, along with the necessary information to identify my identity, to Par Araştırma ve Danışmanlık Anonim Şirketi located at Maslak Mah. Eski Büyükdere Cad. No.37 İçkapı no 8 Sarıyer/Istanbul, either in person with documents identifying my identity, through a notary public, or by other methods specified in the KVK Law.</p>
                    
                    <p>Additionally, I acknowledge and declare that the personal data I have shared with the <i>"Sensiz olmaz, Sessiz olmaz" Project</i> and Portal conducted by Par Araştırma ve Danışmanlık Anonim Şirketi is accurate and up-to-date; and that I will notify any changes to this information.</p>
                    <p>I give my explicit consent to the processing of my personal data, including my special category personal data as defined in the KVK Law, to be used and shared within the scope of the relevant process and for the purpose of processing, and to be stored for the required period. I have been duly informed about this matter; I have read and understood this text, the Information/Clarification Text regarding the Processing of Personal Data within the scope of the Sensiz Olmaz, Sessiz Olmaz project, and I have been informed about the Data Subject Application Form. I accept the Explicit Consent Approval form within the scope of the Law on the Protection of Personal Data.</p>
                    <p>Our policy on the processing and protection of personal data <a rel="noreferrer" href="https://www.sensizolmazsessizolmaz.org/politika.pdf" target="_blank" >www.sensizolmazsessizolmaz.org/politika.pdf</a></p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>              

                  </React.Fragment>              
                  
                }
            </div>
          </div>
        </Popup>        
      </React.Fragment>      
    );
  }
}

const mapStateToProps = state => {
  return {
    step5: state.definitions.step5,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType,
    currentPage: state.project.currentPage,
    showLoading: state.project.showLoading,
    language: state.project.language

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setStep5: (step5) => dispatch({ type: DefinitionsActionTypes.SET_STEP5, step5: step5}),
    setCurrent: (value) => dispatch({type: ProjectActionTypes.SET_CURRENT, value: value }),
    setLoading: (showLoading) => dispatch({ type: ProjectActionTypes.SET_LOADING, showLoading: showLoading}),
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Step5));